import { IFolderMoveDestinations } from '@interfaces/portal/dto/foldersManagementDTO';
import { IDestinationFolderForMove } from '../interfaces';

interface IFlatMoveFolder {
	folder: IDestinationFolderForMove;
	depth: number;
}

export const flattenMoveDestinations = (
	destinations: IFolderMoveDestinations,
): IFlatMoveFolder[] => {
	const result: IFlatMoveFolder[] = [];

	result.push({
		folder: {
			folderId: destinations.id,
			folderName: destinations.name,
			folderHasContent: destinations.hasContent,
		},
		depth: 0,
	});

	for (const folder of destinations.folders) {
		result.push({
			folder: {
				folderId: folder.id,
				folderName: folder.name,
				folderHasContent: folder.hasContent,
			},
			depth: 1,
		});
	}

	return result;
};
